export default __webpack_public_path__ + "static/media/home-decor-4.5b448fd3.jpg";